var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", [
        _vm._v("A-PZN\n    "),
        _c(
          "button",
          {
            staticClass: "btn btn-default btn-xs",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.addRecord()
              },
            },
          },
          [_vm._v("Добавить код\n    ")]
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.records, function (r, i) {
        return [
          r.alias === "apzn" && !r.to_delete
            ? _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: r.text_value,
                      expression: "r.text_value",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: r.text_value },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(r, "text_value", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.removeRecord(i)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }